import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";

import { AppConfig } from "../app.config";

@Injectable({
  providedIn: "root"
})
export class GtmService {
  private renderer: Renderer2;
  private googleTagManagerId: string;

  constructor(appConfig: AppConfig, rendererFactory: RendererFactory2) {
    this.googleTagManagerId = appConfig.getGoogleTagManagerId();
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public loadGtm(): void {
    if (this.googleTagManagerId) {
      const script = this.renderer.createElement("script");
      this.renderer.setAttribute(
        script,
        "src",
        `https://www.googletagmanager.com/gtm.js?id=${this.googleTagManagerId}`
      );
      this.renderer.setAttribute(script, "async", "true");
      this.renderer.appendChild(document.head, script);

      script.onload = () => {
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
          const f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l !== "dataLayer" ? "&l=" + l : "";
          (j as any).async = true;
          (j as any).src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
          f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", this.googleTagManagerId);
      };

      const noScript = this.renderer.createElement("noscript");
      const iframe = this.renderer.createElement("iframe");
      this.renderer.setAttribute(
        iframe,
        "src",
        `https://www.googletagmanager.com/ns.html?id=${this.googleTagManagerId}`
      );
      this.renderer.setStyle(iframe, "display", "none");
      this.renderer.setStyle(iframe, "visibility", "hidden");
      this.renderer.setProperty(iframe, "width", "0");
      this.renderer.setProperty(iframe, "height", "0");

      this.renderer.appendChild(noScript, iframe);
      const body = document.body;
      const firstChild = body.firstChild;
      if (firstChild) {
        this.renderer.insertBefore(body, noScript, firstChild);
      } else {
        this.renderer.appendChild(body, noScript);
      }
    }
  }
}
